import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__ml_asset } from '@shared/dto/+model/sd/ml_asset/DTO__ml_asset';
import { ENUM__redux_action } from '../_base/ENUM__redux_action';
import { StateMLAsset } from './state_ml_asset';

export const local_ml_asset_upsert_model = (payload: DTO__ml_asset[]): PayloadAction<DTO__ml_asset[]> => ({
  type: ENUM__redux_action.ML_ASSET_UPSERT_MODEL,
  payload,
});

export function init_local_ml_asset_upsert_model(state: StateMLAsset, action: PayloadAction<DTO__ml_asset[]>) {
  if (action.payload.length == 0) return;

  for (let diffusion_model of action.payload) {
    state.ml_assets_map.set(diffusion_model._id, diffusion_model);
  }

  //need to force re-render
  state.ml_assets_map = new Map(state.ml_assets_map);
}
